import React from "react";
import PredictionMetrics from "../../atoms/predictionMetrics/PredictionMetrics.jsx";
import SimulationTable from "../simulationTable/SimulationTable.jsx";
import "./EventCard.css";
import { useTranslation } from "react-i18next";

const EventCard = ({
  item,
  isSelected,
  isLoading,
  onSelect,
  formatDate,
  formatDateShort,
  convertToHectares,
}) => {
  const { t } = useTranslation();

  const fire = item.fire;

  return (
    <div
      className={`event-card ${isSelected ? "event-card--selected" : ""}`}
      onClick={() => onSelect(fire.id)}
    >
      <div className="event-card__header">
        <span className="event-ref-badge">{fire.reference}</span>
        <span className="event-address">{fire.address}</span>

        <div className="event-card__header-right">
          {isLoading && (
            <div className="event-card__inline-loader">
              <div className="event-card__spinner" />
              <span className="event-card__loading-text">
                {" "}
                {t("userHistoricEvents.eventCard.loading")}
              </span>
            </div>
          )}
          <span className="event-date-badge">
            {formatDateShort(fire.created_at)}
          </span>
        </div>
      </div>

      <div className="event-card__body">
        <div className="event-meta-row">
          <div className="meta-item">
            <span className="meta-label">
              {t("userHistoricEvents.eventCard.weatherLabel")}
            </span>
            <span className="meta-value">
              {fire.type === "dynamic"
                ? t("userHistoricEvents.eventCard.weatherSatellite")
                : t("userHistoricEvents.eventCard.weatherSimulation")}
            </span>
          </div>
          <div className="meta-item">
            <span className="meta-label">
              {t("userHistoricEvents.eventCard.surfaceLabel")}
            </span>
            <span className="meta-value">
              {convertToHectares(fire.area_m2)}{" "}
              {t("userHistoricEvents.eventCard.hectareUnit")}
            </span>
          </div>
          <div className="meta-item">
            <span className="meta-label">
              {" "}
              {t("userHistoricEvents.eventCard.primaryContourLabel")}
            </span>
            <span className="meta-value">
              {formatDate(fire.date_first_outline)}
            </span>
          </div>
          <div className="meta-item">
            <span className="meta-label">
              {t("userHistoricEvents.eventCard.fireOriginLabel")}
            </span>
            <span className="meta-value">{formatDate(fire.date)}</span>
          </div>
        </div>

        <PredictionMetrics fire={fire} />
        <SimulationTable item={item} />
      </div>
    </div>
  );
};

export default EventCard;
